export default {
  viewBox: "0 0 25 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4 5h17c.5 0 1 .4 1 1v12c0 .5-.5 1-1 1H4c-.6 0-1-.5-1-1V6c0-.6.4-1 1-1m16 12V7h-2.5v10zM5 17h10.5V7H5z\" clip-rule=\"evenodd\"/>"
};